import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as R from 'ramda'
import { usePlace } from './usePlace'
import effects from 'app/effects/effects'
import { loadCompletedSteps } from 'app/store/actions/setupSteps.actions'
import { useIsAuthorized } from 'app/auth/authHooks'

export const useSetupSteps = () => {
  const dispatch = useDispatch()
  const place = usePlace()
  const placeId = R.prop('id', place)
  const isAuthorized = useIsAuthorized()

  useEffect(() => {
    if (placeId && isAuthorized)
      effects.apis
        .setupAccount({ placeId })
        .then(R.compose(dispatch, loadCompletedSteps))
  }, [placeId, dispatch])
}

export const SetupStepTypes = {
  CONFIRM_EMAIL: 1,
  COMPLETE_PROFILE: 2,
  CREATE_GROUP: 3,
  BUILD_SUBSCRIBER: 4,
  INVITE_TEAM: 5,
  INVITE_SUBSCRIBER: 6,
  CREATE_INITIAL_NOTIFICATION: 7,
  NOTIFICATION_SEND: 8,
  SETUP_BILL_PAY: 9,
}
